import React from 'react';
import useUserContext from 'Context/UserContext';
import Investigation from './Investigation';
import { useApexAdminPortalStateContext, useApexAdminPortalDispatchContext } from '../../ApexAdminPortalContext';
import { fetchFromURLParamsFromWebhook } from '../../ApexAdminPortalActions';

const Appeal = () => {
  const { userResource } = useUserContext();
  const { investigationResource, refreshLink } = useApexAdminPortalStateContext();
  const apexDispatch = useApexAdminPortalDispatchContext();

  if (!investigationResource) {
    return null;
  }
  return (
    <Investigation
      resource={investigationResource}
      refreshResource={() => {
        fetchFromURLParamsFromWebhook(userResource, refreshLink, apexDispatch);
      }}
    />
  );
};

export default Appeal;
